import { TPaymentSeverity } from 'common/types/payment-diagnostics';

export const severityTagColor = (severity: TPaymentSeverity) => {
  switch (severity) {
    case 'critical':
      return 'red';
    case 'warning':
      return 'orange';
    default:
      return 'blue';
  }
};

export const severityAlertType = (severity: TPaymentSeverity) => {
  switch (severity) {
    case 'critical':
      return 'error' as const;
    case 'warning':
      return 'warning' as const;
    default:
      return 'success' as const;
  }
};

/** Timeline dots only accept a small set of named colors in antd. */
export const severityTimelineColor = (severity: TPaymentSeverity) => {
  switch (severity) {
    case 'critical':
      return 'red';
    case 'warning':
      return 'orange';
    default:
      return 'blue';
  }
};

export const eventOutcomeColor = (outcome: string) => {
  switch (outcome) {
    case 'success':
    case 'processed':
      return 'green';
    case 'failure':
    case 'processing_failed':
    case 'rejected':
    case 'rejected_transaction_ref_mismatch':
      return 'red';
    case 'duplicate':
    case 'ignored':
    case 'non_success_status':
      return 'orange';
    default:
      return 'blue';
  }
};

export const webhookOutcomeColor = (outcome: string) => {
  switch (outcome) {
    case 'PROCESSED':
      return 'green';
    case 'REJECTED':
    case 'VALIDATION_FAILED':
    case 'PROCESSING_FAILED':
      return 'red';
    default:
      return 'blue';
  }
};

export const attemptStatusColor = (status?: string | null) => {
  switch (status) {
    case 'COMPLETED':
      return 'green';
    case 'FAILED':
    case 'CREATE_FAILED':
      return 'red';
    case 'CORE_APPLIED':
    case 'SIDE_EFFECTS_PROCESSING':
      return 'orange';
    default:
      return 'blue';
  }
};

export const formatDuration = (durationMs?: number | null) => {
  if (durationMs === null || durationMs === undefined) {
    return '—';
  }

  if (durationMs < 1000) {
    return `${durationMs}ms`;
  }

  return `${(durationMs / 1000).toFixed(1)}s`;
};

export const hasDetails = (details?: Record<string, unknown>) =>
  !!details && Object.keys(details).length > 0;
